import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import "../Admin/Admin.css";
import { partnerLogout } from "./PartnerGuard";

export default function PartnerLayout() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const partnerUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("partnerUser") || "{}");
    } catch {
      return {};
    }
  })();

  return (
    <div className="admin-root admin-layout partner-layout">
      {sidebarOpen ? (
        <button
          type="button"
          className="admin-overlay"
          aria-label="Close menu"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="admin-sidebar-head">
          <h2>Partner Panel</h2>
          <span>{partnerUser.email || "Partner"}</span>
        </div>
        <nav className="admin-nav">
          <NavLink to="/partner" end onClick={() => setSidebarOpen(false)}>
            Dashboard
          </NavLink>
          <NavLink to="/partner/cars" onClick={() => setSidebarOpen(false)}>
            Assigned Cars
          </NavLink>
          <NavLink to="/partner/test-drives" onClick={() => setSidebarOpen(false)}>
            Test Drive Inbox
          </NavLink>
        </nav>
        <div className="admin-sidebar-foot">
          <button
            type="button"
            className="admin-btn admin-btn-ghost"
            style={{ width: "100%" }}
            onClick={() => partnerLogout(navigate)}
          >
            Logout
          </button>
        </div>
      </aside>
      <div className="admin-main">
        <header className="admin-topbar">
          <button
            type="button"
            className="admin-menu-toggle"
            aria-label="Open menu"
            onClick={() => setSidebarOpen(true)}
          >
            ☰
          </button>
          <h1>Partner Workspace</h1>
          <button type="button" className="admin-btn admin-btn-ghost" onClick={() => navigate("/")}>
            View Site
          </button>
        </header>
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
